"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var globals_1 = require("./globals");
var sortablejs_service_1 = require("./sortablejs.service");
var sortablejs_bindings_1 = require("./sortablejs-bindings");
var OriginalSortable = require('sortablejs');
var SortablejsDirective = (function () {
    function SortablejsDirective(globalConfig, service, element, zone, cdr) {
        this.globalConfig = globalConfig;
        this.service = service;
        this.element = element;
        this.zone = zone;
        this.cdr = cdr;
        this.runInsideAngular = false;
    }
    SortablejsDirective.prototype.ngOnInit = function () {
        var _this = this;
        if (this.runInsideAngular) {
            this._sortable = OriginalSortable.create(this.element.nativeElement, this.options);
        }
        else {
            this.zone.runOutsideAngular(function () {
                _this._sortable = OriginalSortable.create(_this.element.nativeElement, _this.options);
            });
        }
    };
    SortablejsDirective.prototype.ngOnChanges = function (changes) {
        var _this = this;
        var optionsChange = changes['inputOptions'];
        if (optionsChange && !optionsChange.isFirstChange()) {
            var previousOptions_1 = optionsChange.previousValue;
            var currentOptions_1 = optionsChange.currentValue;
            Object.keys(currentOptions_1).forEach(function (optionName) {
                if (currentOptions_1[optionName] !== previousOptions_1[optionName]) {
                    _this._sortable.option(optionName, currentOptions_1[optionName]);
                }
            });
        }
    };
    SortablejsDirective.prototype.ngOnDestroy = function () {
        if (this._sortable) {
            this._sortable.destroy();
        }
    };
    SortablejsDirective.prototype.getBindings = function () {
        if (!this.sortablejs) {
            return new sortablejs_bindings_1.SortablejsBindings([]);
        }
        else if (this.sortablejs instanceof sortablejs_bindings_1.SortablejsBindings) {
            return this.sortablejs;
        }
        else {
            return new sortablejs_bindings_1.SortablejsBindings([this.sortablejs]);
        }
    };
    Object.defineProperty(SortablejsDirective.prototype, "options", {
        get: function () {
            return Object.assign({}, this.globalConfig || {}, this.inputOptions, this.overridenOptions);
        },
        enumerable: true,
        configurable: true
    });
    SortablejsDirective.prototype.proxyEvent = function (eventName, event) {
        if (this.inputOptions && this.inputOptions[eventName]) {
            this.inputOptions[eventName](event);
        }
        this.cdr.detectChanges();
    };
    Object.defineProperty(SortablejsDirective.prototype, "overridenOptions", {
        get: function () {
            var _this = this;
            return {
                onAdd: function (event) {
                    _this.service.onremove = function (items) { return _this.getBindings().injectIntoEvery(event.newIndex, items); };
                    _this.proxyEvent('onAdd', event);
                },
                onRemove: function (event) {
                    var bindings = _this.getBindings();
                    if (bindings.provided) {
                        _this.service.onremove(bindings.extractFromEvery(event.oldIndex));
                        _this.service.onremove = null;
                    }
                    _this.proxyEvent('onRemove', event);
                },
                onUpdate: function (event) {
                    var bindings = _this.getBindings();
                    bindings.injectIntoEvery(event.newIndex, bindings.extractFromEvery(event.oldIndex));
                    _this.proxyEvent('onUpdate', event);
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    return SortablejsDirective;
}());
SortablejsDirective.decorators = [
    { type: core_1.Directive, args: [{
                selector: '[sortablejs]'
            },] },
];
SortablejsDirective.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: core_1.Optional }, { type: core_1.Inject, args: [globals_1.GLOBALS,] },] },
    { type: sortablejs_service_1.SortablejsService, },
    { type: core_1.ElementRef, },
    { type: core_1.NgZone, },
    { type: core_1.ChangeDetectorRef, },
]; };
SortablejsDirective.propDecorators = {
    'sortablejs': [{ type: core_1.Input, args: ['sortablejs',] },],
    'inputOptions': [{ type: core_1.Input, args: ['sortablejsOptions',] },],
    'runInsideAngular': [{ type: core_1.Input },],
};
exports.SortablejsDirective = SortablejsDirective;
//# sourceMappingURL=sortablejs.directive.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-sortablejs/dist/src/sortablejs.directive.js
// module id = 128
// module chunks = 4